import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import colorSharp from "../assets/img/UI-UX design.gif";
import img from "../assets/img/hero.8f9190d875c91d5c4a5000b756b6f940.svg";
import React from "react";
import HeadButton from "./HeadButton";
import ExperienceCard from "./ExperienceCard";
import TrackVisibility from "react-on-screen";

const imageStyle = {
  position: "absolute",
  top: "1310px",
  zIndex: "0",
  width: "1572px",
  height: "680px",
  objectFit: "cover",
  color: "transparent",
};

const experiences = [
  {
    title: "Web Developer (Contract)",
    company: "iBase Technologies",
    date: "(Apr 2025 - Present)",
  },
  {
    title: "Jr. Software Developer",
    company: "MSBC Group.",
    date: "(Sept 2022 - Dec 2024)",
  },
  {
    title: "Java Developer",
    company: "Neurosynaptic Communications Private Limited",
    date: "(Aug 2021 - Nov 2021)",
  },
];

const Experience = () => {
  return (
    <section className="experience" id="experience">
      <Container style={{ padding: "15px" }}>
        <Row className="align-items-center">
          <HeadButton label="Experience" labelFontSize="1.5rem" />

          <Col xs={12} md={6} xl={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <img
                    src={colorSharp}
                    alt="Profile Img"
                    style={{
                      borderRadius: "15px",
                      borderImage: "15px",
                      height: "90%",
                      width: "90%",
                    }}
                  />
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={6}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "25px" }}
            >
              {experiences.map((experience, index) => (
                <ExperienceCard
                  key={index}
                  title={experience.title}
                  company={experience.company}
                  date={experience.date}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
      <hr />
      <img
        alt="Hero"
        loading="lazy"
        decoding="async"
        data-nimg="1"
        style={imageStyle}
        src={img}
      />
    </section>
  );
};

export default Experience;
